export default{
    bigger:24,
    tableHeader:18,
    tableBody:14,
    big:16,
    regular:14,
    small:12,
    smaller:11
}


// WEBPACK FOOTER //
// ./src/styles/fonts.js